function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M10.406 6.578a.5.5 0 010 .844L2.268 12.6a.5.5 0 01-.768-.421V1.822a.5.5 0 01.768-.422l8.138 5.178z",
  fill: "currentColor",
  stroke: "currentColor"
});

function SvgPlayArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAxMiAxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEwLjQwNTggNi41Nzg0M0MxMC43MTQ2IDYuNzc0OTEgMTAuNzE0NiA3LjIyNTYyIDEwLjQwNTggNy40MjIwOUwyLjI2ODQ0IDEyLjYwMDRDMS45MzU1OCAxMi44MTIyIDEuNSAxMi41NzMxIDEuNSAxMi4xNzg2TDEuNSAxLjgyMTkzQzEuNSAxLjQyNzM5IDEuOTM1NTcgMS4xODgyOCAyLjI2ODQ0IDEuNDAwMUwxMC40MDU4IDYuNTc4NDNaIiBmaWxsPSJjdXJyZW50Q29sb3IiIHN0cm9rZT0iY3VycmVudENvbG9yIi8+Cjwvc3ZnPgo=";
export { SvgPlayArrow as ReactComponent };